

import { getDicomAttributeByTag } from '../util/dicomAttributesTags';
import { StudyInfo } from './StudyInfo';
import { getDicomJsonObjectValue } from './dicomJsonObjectParser';


const assignResultValuesToStudyInfo = (resultStudy, studyInfo) => {

    for (const elementTag in resultStudy) {
      const dicomJsonObject = resultStudy[elementTag];
      const resultValue = getDicomJsonObjectValue(dicomJsonObject);
      const attribute = getDicomAttributeByTag(elementTag) ?? elementTag;
      studyInfo[attribute] = resultValue;
    }
}
  

export const createStudyInfoFromResult = (resultStudy) => {
    const studyInfo = new StudyInfo();
    assignResultValuesToStudyInfo(resultStudy, studyInfo);
    return studyInfo;
}
  